import React from 'react';
import { Link } from 'react-router-dom';
import StartButton from '@/components/site/StartButton';
import SectionHeader from '@/components/site/SectionHeader';
import GoldText from '@/components/site/GoldText';
import { operatingCostNote, pilotComponents, pilotScopeNote } from '@/content/pilot';

const PilotOffer = () => (
  <section id="pilot" aria-labelledby="pilot-title" className="border-t border-rule">
    <div className="section-container grid gap-12 lg:grid-cols-[0.85fr_1.15fr]">
      <div>
        <SectionHeader
          id="pilot-title"
          eyebrow="04 / The pilot"
          title={
            <>
              One workflow. One assistant. <GoldText>A clear test.</GoldText>
            </>
          }
        >
          <p>
            A focused engagement to find out how an AI assistant performs inside your business—before you invest in a
            larger rollout.
          </p>
        </SectionHeader>
        <div className="reveal mt-8 space-y-4 text-sm text-mist">
          <p>
            <span className="font-semibold text-softwhite">Scope. </span>
            {pilotScopeNote}
          </p>
          <p>
            <span className="font-semibold text-softwhite">Operating costs. </span>
            {operatingCostNote}
          </p>
        </div>
        <Link to="/pilot" className="text-link mt-8 inline-block">
          Explore the full pilot →
        </Link>
      </div>

      <div className="surface surface-lit reveal overflow-hidden">
        <div className="flex flex-wrap items-end justify-between gap-4 border-b border-rule p-6 sm:p-8">
          <div>
            <p className="eyebrow mb-1">Offer</p>
            <h3 className="text-3xl">AI Assistant Pilot</h3>
          </div>
          <p className="text-right">
            <span className="block font-serif text-6xl leading-none">
              <span className="gold-shine">Scoped</span>
            </span>
            <span className="meta-label">Confirmed before kickoff</span>
          </p>
        </div>
        <table className="w-full text-left">
          <caption className="sr-only">What the pilot covers</caption>
          <thead className="sr-only">
            <tr>
              <th scope="col">Component</th>
              <th scope="col">What it covers</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-rule">
            {pilotComponents.map((c) => (
              <tr key={c.name} className="align-top">
                <th scope="row" className="w-2/5 px-6 py-4 font-medium sm:px-8">
                  {c.name}
                </th>
                <td className="px-6 py-4 text-mist sm:pr-8 sm:pl-0">{c.covers}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex flex-col gap-4 border-t border-rule p-6 sm:flex-row sm:items-center sm:justify-between sm:p-8">
          <p className="text-sm text-mist">Begin with discovery. We confirm fit, scope, and costs before you commit.</p>
          <StartButton className="shrink-0" />
        </div>
      </div>
    </div>
  </section>
);

export default PilotOffer;
